import {BASE_URL} from "../../config/network";

const searchAddressAPI = async ({address}) => {

    const URL = `${BASE_URL}/public/location/autocomplete?address=${address}`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    console.log("GET Search address")

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    })

    if (!response.ok) {
        console.log("GET Search address ERROR")
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {searchAddressAPI}